var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "pa-0 fill-height",
      staticStyle: { overflow: "hidden" },
      attrs: { fluid: "" },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "120" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-form",
        {
          ref: "form",
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            "v-layout",
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "rounded-card pa-4",
                      staticStyle: { width: "100%" },
                      attrs: { color: _vm.colorman() },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "pb-0" },
                        [
                          _c(
                            "v-row",
                            { attrs: { justify: "start", "no-gutters": "" } },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "pr-2", attrs: { large: "" } },
                                [_vm._v("mdi-clock-plus-outline ")]
                              ),
                              _c(
                                "h3",
                                {
                                  class: _vm.$vuetify.theme.dark
                                    ? "dark"
                                    : "light",
                                },
                                [_vm._v(_vm._s(_vm.$t("postWorktime")))]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", rounded: "" },
                                  on: { click: _vm.refreshEntrys },
                                },
                                [_vm._v(_vm._s(_vm.$t("resetInputs")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            { staticClass: "pt-8", attrs: { cols: "12" } },
                            [
                              _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _vm.employeeShow
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "px-9 py-4",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  staticClass: "py-4",
                                                  attrs: { cols: "2" },
                                                },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      class: _vm.$vuetify.theme
                                                        .dark
                                                        ? "dark"
                                                        : "light",
                                                      attrs: {
                                                        justfiy: "center",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("employees")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c("v-autocomplete", {
                                                staticStyle: {
                                                  "border-radius": "2em / 5em",
                                                },
                                                attrs: {
                                                  items: _vm.employees,
                                                  dense: "",
                                                  "item-text": "name",
                                                  "item-value": "SAPEmpID",
                                                  color: "primary",
                                                  width: "auto",
                                                  locale: "de-de",
                                                  required: "",
                                                  solo: "",
                                                  "hide-details": "",
                                                  rounded: "",
                                                  outlined: "",
                                                  autocomplete: "off",
                                                  "return-object": "",
                                                },
                                                model: {
                                                  value: _vm.selectedEmployee,
                                                  callback: function ($$v) {
                                                    _vm.selectedEmployee = $$v
                                                  },
                                                  expression:
                                                    "selectedEmployee",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          staticClass: "px-9 py-2",
                                          attrs: { justify: "center" },
                                        },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "py-4",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  class: _vm.$vuetify.theme.dark
                                                    ? "dark"
                                                    : "light",
                                                  attrs: { justfiy: "center" },
                                                },
                                                [_vm._v(_vm._s(_vm.$t("date")))]
                                              ),
                                            ]
                                          ),
                                          _c("mydatepicker", {
                                            attrs: {
                                              min: _vm.minDate,
                                              max: _vm.maxDate,
                                              allowedDates: _vm.allowedDates,
                                              dense: "",
                                              notcurentdate: false,
                                              userId: _vm.userIdForDatePicker,
                                            },
                                            on: {
                                              next: function ($event) {
                                                return _vm.setMaxAndMinTime()
                                              },
                                              monthChanged: _vm.setAbsences,
                                            },
                                            model: {
                                              value: _vm.date,
                                              callback: function ($$v) {
                                                _vm.date = $$v
                                              },
                                              expression: "date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12" } },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "pl-12 py-2" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "py-4",
                                                      attrs: {
                                                        cols: "4",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "startTime"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      readonly: "",
                                                      solo: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.startTime.TimeDialog = true
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.startTime.Time,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.startTime,
                                                          "Time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "startTime.Time",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: {
                                                        persistent: "",
                                                        "max-width": "350",
                                                      },
                                                      on: {
                                                        "click:outside":
                                                          function ($event) {
                                                            _vm.startTime.TimeDialog = false
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.startTime
                                                            .TimeDialog,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.startTime,
                                                            "TimeDialog",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "startTime.TimeDialog",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        [
                                                          _c("v-card-title", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "headline",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "selectTime"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "v-time-picker",
                                                                {
                                                                  attrs: {
                                                                    format:
                                                                      "24hr",
                                                                    color:
                                                                      "primary",
                                                                    scrollable:
                                                                      "",
                                                                    min: _vm
                                                                      .startTime
                                                                      .min,
                                                                    max: _vm
                                                                      .startTime
                                                                      .max,
                                                                    rules:
                                                                      _vm
                                                                        .startTime
                                                                        .rules,
                                                                    disabled:
                                                                      _vm
                                                                        .startTime
                                                                        .disabled,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .startTime
                                                                        .Time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.startTime,
                                                                          "Time",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "startTime.Time",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.startTime.TimeDialog = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "close"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "pr-12 py-2" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row-reverse py-4",
                                                      attrs: { cols: "4" },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("endTime")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      readonly: "",
                                                      solo: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.endTime.TimeDialog = true
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.endTime.Time,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.endTime,
                                                          "Time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "endTime.Time",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: {
                                                        persistent: "",
                                                        "max-width": "350",
                                                      },
                                                      on: {
                                                        "click:outside":
                                                          function ($event) {
                                                            _vm.endTime.TimeDialog = false
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.endTime
                                                            .TimeDialog,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.endTime,
                                                            "TimeDialog",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "endTime.TimeDialog",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        [
                                                          _c("v-card-title", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "headline",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "selectTime"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "v-time-picker",
                                                                {
                                                                  attrs: {
                                                                    format:
                                                                      "24hr",
                                                                    color:
                                                                      "primary",
                                                                    scrollable:
                                                                      "",
                                                                    min: _vm
                                                                      .endTime
                                                                      .min,
                                                                    max: _vm
                                                                      .endTime
                                                                      .max,
                                                                    rules:
                                                                      _vm
                                                                        .endTime
                                                                        .rules,
                                                                    disabled:
                                                                      _vm
                                                                        .endTime
                                                                        .disabled,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .endTime
                                                                        .Time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.endTime,
                                                                          "Time",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "endTime.Time",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.endTime.TimeDialog = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "close"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.workTime != "00:00"
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "body-1",
                                                  style: {
                                                    color: _vm.$vuetify.theme
                                                      .dark
                                                      ? "white"
                                                      : "#B31616",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("sumWorkTime")
                                                    ) +
                                                      " : " +
                                                      _vm._s(_vm.workTime)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pt-8",
                                      attrs: { cols: "12" },
                                    },
                                    _vm._l(_vm.pause, function (p, index) {
                                      return _c(
                                        "v-row",
                                        { key: p.id, attrs: { cols: "12" } },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "pl-12 py-4" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "4",
                                                        justify: "center ",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "pauseStart"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      readonly: "",
                                                      solo: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        p.pauseStart.TimeDialog = true
                                                      },
                                                    },
                                                    model: {
                                                      value: p.pauseStart.Time,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          p.pauseStart,
                                                          "Time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "p.pauseStart.Time",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: {
                                                        persistent: "",
                                                        "max-width": "350",
                                                      },
                                                      on: {
                                                        "click:outside":
                                                          function ($event) {
                                                            ;(p.pauseStart.TimeDialog = false),
                                                              _vm.setPauseStart(
                                                                index
                                                              )
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          p.pauseStart
                                                            .TimeDialog,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            p.pauseStart,
                                                            "TimeDialog",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "p.pauseStart.TimeDialog",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        [
                                                          _c("v-card-title", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "headline",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "selectTime"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "v-time-picker",
                                                                {
                                                                  attrs: {
                                                                    format:
                                                                      "24hr",
                                                                    color:
                                                                      "primary",
                                                                    scrollable:
                                                                      "",
                                                                    rules:
                                                                      p
                                                                        .pauseStart
                                                                        .rules,
                                                                    disabled:
                                                                      p
                                                                        .pauseStart
                                                                        .disabled,
                                                                    min: p
                                                                      .pauseStart
                                                                      .min,
                                                                    max: p
                                                                      .pauseStart
                                                                      .max,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setPauseStart(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      p
                                                                        .pauseStart
                                                                        .Time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          p.pauseStart,
                                                                          "Time",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "p.pauseStart.Time",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        ;(p.pauseStart.TimeDialog = false),
                                                                          _vm.setPauseStart(
                                                                            index
                                                                          )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "close"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-row",
                                                { staticClass: "pr-12 py-2" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row-reverse py-4",
                                                      attrs: { cols: "4" },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("pauseEnd")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-text-field", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      dense: "",
                                                      readonly: "",
                                                      solo: "",
                                                      outlined: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        p.pauseEnd.TimeDialog = true
                                                      },
                                                    },
                                                    model: {
                                                      value: p.pauseEnd.Time,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          p.pauseEnd,
                                                          "Time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "p.pauseEnd.Time",
                                                    },
                                                  }),
                                                  _c(
                                                    "v-dialog",
                                                    {
                                                      attrs: {
                                                        persistent: "",
                                                        "max-width": "350",
                                                      },
                                                      on: {
                                                        "click:outside":
                                                          function ($event) {
                                                            p.pauseEnd.TimeDialog = false
                                                          },
                                                      },
                                                      model: {
                                                        value:
                                                          p.pauseEnd.TimeDialog,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            p.pauseEnd,
                                                            "TimeDialog",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "p.pauseEnd.TimeDialog",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-card",
                                                        [
                                                          _c("v-card-title", [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "headline",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "selectTime"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _c(
                                                            "v-card-text",
                                                            [
                                                              _c(
                                                                "v-time-picker",
                                                                {
                                                                  attrs: {
                                                                    format:
                                                                      "24hr",
                                                                    color:
                                                                      "primary",
                                                                    scrollable:
                                                                      "",
                                                                    rules:
                                                                      p.pauseEnd
                                                                        .rules,
                                                                    disabled:
                                                                      p.pauseEnd
                                                                        .disabled,
                                                                    min: p
                                                                      .pauseEnd
                                                                      .min,
                                                                    max: p
                                                                      .pauseEnd
                                                                      .max,
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.setPauseEnd(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      p.pauseEnd
                                                                        .Time,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          p.pauseEnd,
                                                                          "Time",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "p.pauseEnd.Time",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-card-actions",
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    text: "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        p.pauseEnd.TimeDialog = false
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "close"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { justify: "center" } },
                                            [
                                              _vm.pauseTimeSum != null &&
                                              _vm.pauseTimeSum != "00:00"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "body-1",
                                                      style: {
                                                        color: _vm.$vuetify
                                                          .theme.dark
                                                          ? "white"
                                                          : "#B31616",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("sumPause")
                                                          ) +
                                                          " : " +
                                                          _vm._s(
                                                            _vm.pauseTimeSum
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                  _c("div", {
                                    staticClass: "divider",
                                    attrs: { align: "center" },
                                  }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: { cols: "6" },
                                    },
                                    [
                                      _vm.$store.getters[
                                        "server/serviceCallsAllowed"
                                      ] == 1 && _vm.canAccessProjectBooking
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "px-0" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "pl-12 py-2",
                                                      attrs: {
                                                        "no-gutters": "",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-2",
                                                          attrs: { cols: "4" },
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              class: _vm
                                                                .$vuetify.theme
                                                                .dark
                                                                ? "dark"
                                                                : "light",
                                                              attrs: {
                                                                justfiy:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "serviceCallCustomer"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        [
                                                          _c("v-autocomplete", {
                                                            staticStyle: {
                                                              "border-radius":
                                                                "2em / 5em",
                                                            },
                                                            attrs: {
                                                              items:
                                                                _vm.customers,
                                                              "item-text":
                                                                _vm.setText,
                                                              dense: "",
                                                              "item-value":
                                                                "SAPEmpID",
                                                              color: "primary",
                                                              width: "auto",
                                                              disabled:
                                                                _vm.customersDisabled,
                                                              locale: "de-de",
                                                              required: "",
                                                              solo: "",
                                                              "hide-details":
                                                                "",
                                                              rounded: "",
                                                              outlined: "",
                                                              autocomplete:
                                                                "off",
                                                              "return-object":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedCustomer,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.selectedCustomer =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "selectedCustomer",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "px-0" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "pl-12 py-2",
                                                      attrs: {
                                                        "no-gutters": "",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-2",
                                                          attrs: { cols: "4" },
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              class: _vm
                                                                .$vuetify.theme
                                                                .dark
                                                                ? "dark"
                                                                : "light",
                                                              attrs: {
                                                                justfiy:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "serviceCall"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        [
                                                          _c("v-autocomplete", {
                                                            staticStyle: {
                                                              "border-radius":
                                                                "2em / 5em",
                                                            },
                                                            attrs: {
                                                              items:
                                                                _vm.serviceCalls,
                                                              "item-text":
                                                                "Subject",
                                                              dense: "",
                                                              "item-value":
                                                                "ServiceCallID",
                                                              rules:
                                                                _vm.serviceCallRules,
                                                              color: "primary",
                                                              disabled:
                                                                _vm.serviceCallDisabled,
                                                              locale: "de-de",
                                                              required: "",
                                                              solo: "",
                                                              "hide-details":
                                                                "",
                                                              rounded: "",
                                                              outlined: "",
                                                              autocomplete:
                                                                "off",
                                                              "return-object":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedServiceCall,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.selectedServiceCall =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "selectedServiceCall",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "px-0" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "pl-12 py-2",
                                                      attrs: {
                                                        "no-gutters": "",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass: "py-2",
                                                          attrs: { cols: "4" },
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              class: _vm
                                                                .$vuetify.theme
                                                                .dark
                                                                ? "dark"
                                                                : "light",
                                                              attrs: {
                                                                justfiy:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "activityType"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "v-col",
                                                        [
                                                          _c("v-autocomplete", {
                                                            ref: "activitytypesDataVref",
                                                            staticStyle: {
                                                              "border-radius":
                                                                "2em / 5em",
                                                            },
                                                            attrs: {
                                                              color: "primary",
                                                              items:
                                                                _vm.activityTypes,
                                                              "item-text":
                                                                "ActivityType",
                                                              "item-value":
                                                                "ActivityID",
                                                              rules:
                                                                _vm.activityRules,
                                                              dense: "",
                                                              disabled:
                                                                _vm.activityTypeDisabled,
                                                              locale: "de-de",
                                                              required: "",
                                                              solo: "",
                                                              "hide-details":
                                                                "",
                                                              rounded: "",
                                                              outlined: "",
                                                              autocomplete:
                                                                "off",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedActivity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.selectedActivity =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "selectedActivity",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pa-0",
                                      attrs: { cols: "6" },
                                    },
                                    [
                                      _vm.$store.getters[
                                        "server/stageProjectsAllowed"
                                      ] == 1 && _vm.canAccessProjectBooking
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "px-0" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    {
                                                      staticClass: "pr-12 py-2",
                                                      attrs: {
                                                        "no-gutters": "",
                                                        justify: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-col",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-row-reverse pr-2 py-2",
                                                          attrs: { cols: "4" },
                                                        },
                                                        [
                                                          _c(
                                                            "h3",
                                                            {
                                                              class: _vm
                                                                .$vuetify.theme
                                                                .dark
                                                                ? "dark"
                                                                : "light",
                                                              attrs: {
                                                                justfiy:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "project"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c("v-autocomplete", {
                                                        staticStyle: {
                                                          "border-radius":
                                                            "2em / 5em",
                                                        },
                                                        attrs: {
                                                          color: "primary",
                                                          dense: "",
                                                          "item-text": _vm
                                                            .$store.getters[
                                                            "server/showFinanceProjectByProjectManagement"
                                                          ]
                                                            ? "FinancialProject"
                                                            : "ProjectName",
                                                          items:
                                                            _vm.stageProjects,
                                                          disabled:
                                                            _vm.stageProjectsDisabled,
                                                          required: "",
                                                          autocomplete: "off",
                                                          solo: "",
                                                          "hide-details": "",
                                                          rounded: "",
                                                          outlined: "",
                                                          "return-object": "",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedStageProject,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.selectedStageProject =
                                                              $$v
                                                          },
                                                          expression:
                                                            "selectedStageProject",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { staticClass: "px-0" },
                                                [
                                                  _vm.$store.getters[
                                                    "server/stageProjectsAllowed"
                                                  ] == 1
                                                    ? _c(
                                                        "v-row",
                                                        {
                                                          staticClass:
                                                            "pr-12 py-2",
                                                          attrs: {
                                                            "no-gutters": "",
                                                            justify: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-row-reverse pr-2 py-2",
                                                              attrs: {
                                                                cols: "4",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "h3",
                                                                {
                                                                  class: _vm
                                                                    .$vuetify
                                                                    .theme.dark
                                                                    ? "dark"
                                                                    : "light",
                                                                  attrs: {
                                                                    justfiy:
                                                                      "center",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "stage"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _c("v-autocomplete", {
                                                            staticStyle: {
                                                              "border-radius":
                                                                "2em / 5em",
                                                            },
                                                            attrs: {
                                                              color: "primary",
                                                              "item-text":
                                                                "Description",
                                                              dense: "",
                                                              "item-value":
                                                                "StageID",
                                                              items: _vm.stages,
                                                              rules:
                                                                _vm.stageRules,
                                                              disabled:
                                                                _vm.stageDisabled,
                                                              required: "",
                                                              autocomplete:
                                                                "off",
                                                              solo: "",
                                                              "hide-details":
                                                                "",
                                                              rounded: "",
                                                              outlined: "",
                                                              "return-object":
                                                                "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.selectedStage,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.selectedStage =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "selectedStage",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { staticClass: "px-0" },
                                        [
                                          _vm.$store.getters[
                                            "server/showCostCentre"
                                          ] == 1
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "pr-12 py-2",
                                                  attrs: {
                                                    "no-gutters": "",
                                                    justify: "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row-reverse pr-2 py-2",
                                                      attrs: { cols: "4" },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                          attrs: {
                                                            justfiy: "center",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "costCentre"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-autocomplete", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      color: "primary",
                                                      "item-text": "CenterName",
                                                      dense: "",
                                                      "item-value":
                                                        "CenterCode",
                                                      items: _vm.profitCenters,
                                                      disabled:
                                                        _vm.profitCenterDisabled,
                                                      required: "",
                                                      autocomplete: "off",
                                                      solo: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                      outlined: "",
                                                      "return-object": "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedProfitCenter,
                                                      callback: function ($$v) {
                                                        _vm.selectedProfitCenter =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedProfitCenter",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { staticClass: "px-0" },
                                        [
                                          _vm.$store.getters[
                                            "server/financeProjectsAllowed"
                                          ] == 1
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass: "pr-12 py-2",
                                                  attrs: {
                                                    "no-gutters": "",
                                                    justify: "center",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass:
                                                        "d-flex flex-row-reverse pr-2 py-2",
                                                      attrs: { cols: "4" },
                                                    },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          class: _vm.$vuetify
                                                            .theme.dark
                                                            ? "dark"
                                                            : "light",
                                                          attrs: {
                                                            justfiy: "center",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "financeProjects"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("v-autocomplete", {
                                                    staticStyle: {
                                                      "border-radius":
                                                        "2em / 5em",
                                                    },
                                                    attrs: {
                                                      color: "primary",
                                                      "item-text": "Name",
                                                      dense: "",
                                                      "item-value": "Code",
                                                      items: _vm.projects,
                                                      disabled:
                                                        _vm.projectDisabled,
                                                      required: "",
                                                      autocomplete: "off",
                                                      solo: "",
                                                      "hide-details": "",
                                                      rounded: "",
                                                      outlined: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedProject,
                                                      callback: function ($$v) {
                                                        _vm.selectedProject =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedProject",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.canAccessProjectBooking
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        display: "flex",
                                        "padding-top": "2rem",
                                      },
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "divider",
                                        staticStyle: { margin: "auto" },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "v-row",
                                {
                                  staticClass: "d-flex",
                                  attrs: { cols: "12" },
                                },
                                [
                                  _c("v-spacer"),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "pr-12 py-8",
                                      attrs: { cols: "6" },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        { attrs: { align: "center" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "pl-0 d-flex flex-row-reverse",
                                              attrs: { cols: "4" },
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  class: _vm.$vuetify.theme.dark
                                                    ? "dark"
                                                    : "light",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("nonBillableTime")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            { staticClass: "px-0" },
                                            [
                                              _c("v-text-field", {
                                                staticStyle: {
                                                  "border-radius": "2em / 5em",
                                                },
                                                attrs: {
                                                  dense: "",
                                                  readonly: "",
                                                  outlined: "",
                                                  solo: "",
                                                  "hide-details": "",
                                                  rounded: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.NonBillableTime.TimeDialog = true
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.NonBillableTime.Time,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.NonBillableTime,
                                                      "Time",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "NonBillableTime.Time",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-dialog",
                                        {
                                          attrs: {
                                            persistent: "",
                                            "max-width": "350",
                                          },
                                          on: {
                                            "click:outside": function ($event) {
                                              _vm.NonBillableTime.TimeDialog = false
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.NonBillableTime.TimeDialog,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.NonBillableTime,
                                                "TimeDialog",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "NonBillableTime.TimeDialog",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("v-card-title", [
                                                _c(
                                                  "span",
                                                  { staticClass: "headline" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("hours"))
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c("v-time-picker", {
                                                    attrs: {
                                                      format: "24hr",
                                                      color: "primary",
                                                      scrollable: "",
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.NonBillableTime
                                                          .Time,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.NonBillableTime,
                                                          "Time",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "NonBillableTime.Time",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-card-actions",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { text: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.NonBillableTime.TimeDialog = false
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("close"))
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "pa-2",
                              attrs: { justify: "end", "no-gutters": "" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ml-4 pa-7",
                                  attrs: { color: "primary", rounded: "" },
                                  on: { click: _vm.send },
                                },
                                [_vm._v(_vm._s(_vm.$t("send")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.ShowProjectComment && _vm.$store.getters["server/allowProjectText"]
        ? _c("ProjectText", {
            on: {
              saveComment: function ($event) {
                _vm.projectComment = $event
                _vm.ShowProjectComment = false
              },
              close: function ($event) {
                _vm.ShowProjectComment = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }